import React, { useEffect, useState } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Card, CardActions, CardContent, Grid, TableCell, TableRow } from 'react-md'
import { format, parseISO } from 'date-fns'

import { ClientAutoComplete, SupplierAutoComplete } from 'components/auto-complete'
import { ConfirmDialog, Cell, PageTitle, ButtonSearch } from 'components/core'
import { handleSubmit, Input, InputDatePicker, Select } from 'components/form'
import { DataTable, DeleteButton, EditButton } from 'components/data-table'
import { DataTableResult } from 'components/data-table/types'
import { formatCurrency } from 'types/core/currency'
import { CompanySelect } from 'components/select'
import {
  DestinationExpenseOptions,
  ExpenseTypeOptions,
  getPayableStatusDescription,
  PayableDocumentTypeOptions,
  PayableStatusOptions,
  StatusOfPaymentMadeOptions,
} from 'types/financial/payable'

import { handleSearch, handleEdit, handleDelete } from './actions'
import { defaultValues, validationSchema } from './config'

const Component: React.FC = () => {
  const form = useForm({ defaultValues })
  const [filter, setFilter] = useState<any>()
  const [result, setResult] = useState<DataTableResult>({ total: 0, results: [] })
  const [deleteId, setDeleteId] = useState<string>()
  const [toogleUpdate, setToogleUpdate] = useState<boolean>(false)

  useEffect(() => {
    document.title = 'Pesquisa de Contas a Pagar'
  }, [])

  return (
    <>
      <Grid>
        <Cell>
          <PageTitle title='Pesquisa de Contas a Pagar' />
          <Card fullWidth>
            <CardContent>
              <FormContext {...form}>
                <Grid>
                  <CompanySelect name='companyId' label='Empresa' desktopSize={4} tabletSize={8} />
                  <SupplierAutoComplete name='supplier' label='Fornecedor' desktopSize={4} tabletSize={8} />
                  <ClientAutoComplete name='client' label='Cliente' desktopSize={4} tabletSize={8} />
                  <InputDatePicker name='initialDueDate' label='Data de Vencimento Inicial' desktopSize={3} tabletSize={4} />
                  <InputDatePicker name='finalDueDate' label='Data de Vencimento Final' desktopSize={3} tabletSize={4} />
                  <Input name='documentNumber' label='Número do Documento' desktopSize={3} tabletSize={4} />
                  <Select name='documentType' label='Tipo do Documento' options={PayableDocumentTypeOptions} desktopSize={3} tabletSize={4} />
                  <InputDatePicker name='initialPaymentDate' label='Data de Pagamento Inicial' desktopSize={3} tabletSize={4} />
                  <InputDatePicker name='finalPaymentDate ' label='Data de Pagamento Final' desktopSize={3} tabletSize={4} />
                  <Select name='status' label='Status' options={PayableStatusOptions} desktopSize={3} tabletSize={4} />
                  <Select name='destinationExpense' label='Destino da Despesa' options={DestinationExpenseOptions} desktopSize={3} tabletSize={4} />
                  <Select name='expenseType' label='Tipo de Gasto' options={ExpenseTypeOptions} desktopSize={3} tabletSize={4} />
                  <Select
                    name='statusOfPaymentMade'
                    label='Status do Pagamento Realizado'
                    options={StatusOfPaymentMadeOptions}
                    desktopSize={3}
                    tabletSize={4}
                  />
                </Grid>
              </FormContext>
              <CardActions>
                <ButtonSearch onClick={async () => await handleSubmit(form, validationSchema, () => setFilter(form.getValues()))} />
              </CardActions>
            </CardContent>
          </Card>
        </Cell>
        <Cell>
          <DataTable
            filter={filter}
            header={[
              { order: 'Company.FantasyName', label: 'Empresa' },
              { order: 'Supplier.FantasyName', label: 'Fornecedor' },
              { order: 'DocumentNumber', label: 'Número do Documento' },
              { order: 'Value', label: 'Valor' },
              { label: 'Status' },
              { order: 'DueDate', label: 'Data de Vencimento' },
              { label: '' },
            ]}
            result={result}
            setResult={setResult}
            search={handleSearch}
            update={toogleUpdate}
            total={result ? result.total : 0}>
            {result &&
              result.results &&
              result.results.map((data: any, index) => (
                <TableRow key={index}>
                  <TableCell>{data.companyFantasyName}</TableCell>
                  <TableCell>{data.supplierFantasyName}</TableCell>
                  <TableCell>{data.documentNumber}</TableCell>
                  <TableCell>{formatCurrency(data.value)}</TableCell>
                  <TableCell>{getPayableStatusDescription(data.status)}</TableCell>
                  <TableCell>{format(parseISO(data.dueDate), "dd'/'MM'/'yyyy")}</TableCell>
                  <TableCell align='right'>
                    <EditButton id={`edit-${index}`} action={() => handleEdit(data.id)} />
                    <DeleteButton id={`delete-${index}`} action={() => setDeleteId(data.id)} />
                  </TableCell>
                </TableRow>
              ))}
          </DataTable>
        </Cell>
      </Grid>
      <ConfirmDialog
        text='Deseja realmente excluir o lançamento? Essa ação não poderá ser desfeita'
        visible={deleteId ? true : false}
        confirmAction={async () => {
          if (deleteId) if (await handleDelete(deleteId)) setToogleUpdate(!toogleUpdate)
          setDeleteId(undefined)
        }}
        cancelAction={async () => setDeleteId(undefined)}
      />
    </>
  )
}

export default Component
